import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  ChevronDownIcon, 
  MagnifyingGlassIcon, 
  CheckIcon,
  GlobeAltIcon 
} from '@heroicons/react/24/outline';

export const LANGUAGES = [
  { code: 'en', name: 'English'},
  { code: 'ru', name: 'Русский'},
  { code: 'oz', name: "O'zbek"},
  // { code: 'es', name: 'Español', flag: '🇪🇸' },
  // { code: 'fr', name: 'Français', flag: '🇫🇷' },
  // { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  // { code: 'zh', name: '中文', flag: '🇨🇳' },
];
const LanguageSelector = ({ variant = 'default', onSelect }) => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const containerRef = useRef(null);

  // Закрытие по клику вне компонента
  useEffect(() => {
    const handleClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const currentLanguage = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  const filteredLanguages = LANGUAGES.filter(lang =>
    lang.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
    setSearchTerm('');
    if (onSelect) onSelect(code);
  };

  // Вариант для вложенного меню (как у тебя в профиле)
  if (variant === 'menu-item') {
    return (
      <div className="px-4 py-2">
        <p className="text-[8px] font-black uppercase tracking-widest text-gray-400 mb-2">{t("nav.language")}</p>
        <button 
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center justify-between py-1.5 px-3 rounded-xl border border-slate-100 hover:border-slate-300 transition-all bg-slate-50 hover:bg-white group"
        >
          <span className="text-[10px] font-bold text-[#0A1128]">{currentLanguage.name}</span>
          <ChevronDownIcon className={`h-3 w-3 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
        </button>
        
        {isOpen && (
          <div className="mt-2 space-y-1 animate-in fade-in slide-in-from-top-2 duration-200">
            {LANGUAGES.map(lang => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className={`w-full text-left px-3 py-2 rounded-lg text-[10px] font-bold transition-colors ${
                  i18n.language === lang.code ? 'bg-orange-50 text-[#F65814]' : 'hover:bg-slate-50 text-slate-600'
                }`}
              >
                {lang.name}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Стандартный вариант (кнопка в шапке для гостей)
  return (
    <div className="relative" ref={containerRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-xl border border-gray-100 hover:border-orange-200 hover:bg-orange-50 transition-all group"
      >
        <GlobeAltIcon className="h-4 w-4 text-slate-400 group-hover:text-[#F65814]" />
        <span className="text-[10px] font-black uppercase tracking-wider text-slate-500 group-hover:text-[#F65814]">
          {currentLanguage.code}
        </span>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-2xl shadow-xl border border-gray-50 overflow-hidden z-[100] animate-in fade-in zoom-in-95 duration-150">
          <div className="p-2 border-b border-gray-50">
            <div className="relative">
              <MagnifyingGlassIcon className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-400" />
              <input 
                type="text"
                autoFocus
                placeholder="Search..."
                className="w-full bg-slate-50 border-none rounded-lg pl-8 pr-3 py-1.5 text-[11px] focus:ring-1 focus:ring-orange-500/20 transition-all"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="max-h-60 overflow-y-auto p-1.5 custom-scrollbar">
            {filteredLanguages.map(lang => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className={`w-full flex items-center justify-between px-3 py-2 rounded-xl transition-all ${
                  i18n.language === lang.code ? 'bg-orange-50 text-[#F65814]' : 'hover:bg-slate-50 text-slate-600'
                }`}
              >
                <span className="text-[10px] font-bold">{lang.name}</span>
                {i18n.language === lang.code && <CheckIcon className="h-3 w-3" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;